import React from 'react';
import { Card, Badge } from '@/components/ui';
import { useNavigate } from 'react-router-dom';
import { LayoutDashboard, HardHat, CircleDollarSign, Users, Truck, Sparkles, ArrowRight } from 'lucide-react';
import { cn } from '@/utils/cn';

export function ReportsModulesGrid() {
  const navigate = useNavigate();

  const MODULES = [
    {
      id: 'overview',
      title: 'Dashboard Tổng hợp',
      description: 'Trạm chỉ huy trung tâm, theo dõi tiến độ tổng thể, chi phí và hiệu suất (Executive Dashboard).',
      icon: <LayoutDashboard className="w-6 h-6" />,
      color: 'blue',
      path: '/reports/overview',
      stats: 'Real-time',
      gradient: 'from-blue-500 to-cyan-500',
      bgLight: 'bg-blue-50',
      textDark: 'text-blue-700'
    },
    {
      id: 'construction',
      title: 'Báo cáo Thi công',
      description: 'Phân tích khối lượng hoàn thành, sản lượng, chất lượng QA/QC và nhật ký công trường.',
      icon: <HardHat className="w-6 h-6" />,
      color: 'amber',
      path: '/reports/construction',
      stats: 'Theo tuần/tháng',
      gradient: 'from-amber-400 to-orange-500',
      bgLight: 'bg-amber-50',
      textDark: 'text-amber-700'
    },
    {
      id: 'financial',
      title: 'Báo cáo Tài chính',
      description: 'Cập nhật ngân sách dự án, dòng tiền (Cashflow), giá trị thanh toán và lỗ lãi dự kiến.',
      icon: <CircleDollarSign className="w-6 h-6" />,
      color: 'emerald',
      path: '/reports/financial',
      stats: 'Chính xác 99%',
      gradient: 'from-emerald-400 to-teal-500',
      bgLight: 'bg-emerald-50',
      textDark: 'text-emerald-700'
    },
    {
      id: 'resources',
      title: 'Phân tích Nguồn lực',
      description: 'Đo lường năng suất nhân sự, biểu đồ huy động lực lượng và tình hình tiêu hao vật tư.',
      icon: <Users className="w-6 h-6" />,
      color: 'purple',
      path: '/reports/resources',
      stats: '15 Báo cáo',
      gradient: 'from-purple-500 to-pink-500',
      bgLight: 'bg-purple-50',
      textDark: 'text-purple-700'
    },
    {
      id: 'equipment',
      title: 'Báo cáo Cơ giới',
      description: 'Hiệu suất khai thác thiết bị, chi phí nhiên liệu, khấu hao và tần suất bảo dưỡng.',
      icon: <Truck className="w-6 h-6" />,
      color: 'slate',
      path: '/reports/equipment',
      stats: 'Khấu hao',
      gradient: 'from-slate-500 to-gray-600',
      bgLight: 'bg-slate-100',
      textDark: 'text-slate-700'
    },
    {
      id: 'builder',
      title: 'Custom Report Builder',
      description: 'Công cụ kéo thả để tự thiết kế báo cáo động (BI Tools) theo nhu cầu của riêng bạn.',
      icon: <Sparkles className="w-6 h-6" />,
      color: 'indigo',
      path: '/reports/builder',
      stats: 'AI Powered',
      gradient: 'from-indigo-500 to-violet-500',
      bgLight: 'bg-indigo-50',
      textDark: 'text-indigo-700'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 h-full">
      {MODULES.map((mod) => (
        <Card
          key={mod.id}
          onClick={() => navigate(mod.path)}
          className="group relative overflow-hidden bg-white border-2 border-slate-100 hover:border-blue-200 shadow-sm hover:shadow-xl rounded-3xl p-6 cursor-pointer transition-all duration-300 hover:-translate-y-1 h-full flex flex-col"
        >
          <div className={cn("absolute top-0 right-0 w-32 h-32 bg-gradient-to-br opacity-5 rounded-bl-full transition-transform duration-500 group-hover:scale-110", mod.gradient)} />

          <div className="flex items-start justify-between mb-4">
            <div className={cn("w-14 h-14 rounded-2xl flex items-center justify-center shadow-inner transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3", mod.bgLight, mod.textDark)}>
              {mod.icon}
            </div>
            <Badge variant="custom" className={cn("bg-slate-50 text-slate-600 border border-slate-100 font-bold px-2.5 py-1 text-[10px]")}>
              {mod.stats}
            </Badge>
          </div>

          <h4 className="text-lg font-black text-slate-800 mb-2 group-hover:text-blue-700 transition-colors">{mod.title}</h4>
          <p className="text-xs text-slate-500 leading-relaxed mb-6 line-clamp-2 min-h-[36px] flex-grow">
            {mod.description}
          </p>

          <div className="flex items-center text-sm font-bold text-blue-600 opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300 mt-auto">
            Truy cập ngay <ArrowRight className="w-4 h-4 ml-1.5" />
          </div>
        </Card>
      ))}
    </div>
  );
}
